import { createFileRoute } from "@tanstack/react-router";

import SetPasswordPage from "~/pages/auth/SetPasswordPage.tsx";

export const Route = createFileRoute("/set-password/$token")({
    component: SetPasswordPage,
});
